// extracted by mini-css-extract-plugin
module.exports = {"modal":"AddNoteModal_modal__3LJNB"};